module.exports = __webpack_public_path__ + "img/header_icon.500f0e53.png";